import { TReduxActions } from '../../../types/redux';
import { EOpenNewAnswerForm } from '../../../actions/newAnswer/openFormActionsTypes';
import { TSetNewAnswerFormOpenPayload } from '../../../actions/newAnswer/openFormActions';

export const defaultValue = null;

export function openReducer(
  state: TSetNewAnswerFormOpenPayload | null = defaultValue,
  { type, payload }: TReduxActions,
): TSetNewAnswerFormOpenPayload | null {
  if (type === EOpenNewAnswerForm.Open) {
    return payload;
  }

  if (type === EOpenNewAnswerForm.Close) {
    return null;
  }

  return state;
}
